import React, { useEffect, useState } from "react";

import MainBtn from "../repeats/mainBtn/MainBtn";
import Reviews from "../reviews/Reviews";
import Footer from "../footer/Footer";
import Post from "./Post";
import { useSelector, useDispatch } from "react-redux";
import blog from "../../assets/images/Blog/Blog_Back.jpg";

import "./Blog.css";
import { getContent } from "../../redux/actions-exporter.js";
import logo from "../nav/Logo";

const Blog = () => {
  const content = useSelector((state) => state.content);
  const [postArr, setPostArr] = useState([]);
  const dispatch = useDispatch();
  // const [start, setStart] = useState(true);

  // useEffect(() => {
  //   if (start) document.querySelector(".homeTitle").scrollIntoView();
  //   setStart(false);
  // }, []);
  useEffect(() => {
    if (!Object.keys(content).length) {
      dispatch(getContent());
    } else {
      let blogData = content.list.filter(
        (item) =>
          item.categories.length > 0 && item.categories[0].title === "blog"
      );
      // .map((item) => item)
      setPostArr(blogData);
    }
  }, [content]);

  return (
    <div className="transport">
      <div className="page_banner page_banner__fixed">
        <img src={blog} alt="" className='blogBanner'/>
        <div className="banner_content">
          <div className="banner_title">
            <h1>הבלוג שלנו</h1>
            <div>בחר את השירות שברצונך להזמין</div>
          </div>
          <div className="btnDiv">
            <MainBtn text="הובלה" link="/transport" />
            <MainBtn text="אחסנה" link="/storage" isLight={true} />
          </div>
        </div>
      </div>

      {/* <Pros />*/}
      <div className="articlesDiv">
        {postArr.map((el, i) => {
          return (
            <Post
              title={el.title}
              description={el.description}
              img={el.image}
              text={el.content}
              key={i}
              id={el.id}
            />
          );
        })}
      </div>
      <Reviews />
      <Footer isContact={true} />
    </div>
  );
};

export default Blog;
